import isEqual from 'lodash-es/isEqual'
import pick from 'lodash-es/pick'

import type { FormValues } from '../AddPaymentMethod.types'

export const hasChargeLimitValuesChanged = (
  values: FormValues,
  initialValues: FormValues,
): boolean => {
  const chargeLimitValues = ['setChargeLimit', 'chargeLimit']

  return !isEqual(pick(values, chargeLimitValues), pick(initialValues, chargeLimitValues))
}
